module.exports = __webpack_public_path__ + "img/transferencia.079eacbf.svg";